module.exports = __webpack_public_path__ + "static/media/TreePermits.019151cf.svg";